module.exports = __webpack_public_path__ + "static/media/plus-icon-blue.10171dd5.svg";